var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 3.005,
    x2: 36,
    y2: 101,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#002d44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#013852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0a4d6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#0f5e82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#0f6d96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#0d77a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#0a7eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0881b2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    fillOpacity: 0,
    stroke: "#01415e",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 71.2H14c1.7 0 2.9.1 3.8.4 1.2.3 2.2 1 3 1.8.8.9 1.5 1.9 1.9 3.2.4 1.3.7 2.8.7 4.7 0 1.6-.2 3-.6 4.2-.5 1.4-1.2 2.6-2.1 3.5-.7.7-1.6 1.2-2.8 1.6-.9.3-2.1.4-3.6.4H6.6V71.2zm4 3.4v13.1h3c1.1 0 1.9-.1 2.4-.2.7-.2 1.2-.4 1.6-.8.4-.4.8-1 1.1-1.9s.4-2.1.4-3.6-.1-2.7-.4-3.5c-.3-.8-.7-1.5-1.1-1.9s-1.1-.8-1.9-.9c-.6-.1-1.7-.2-3.3-.2h-1.8zM26 81.3c0-2 .3-3.7.9-5.1.5-1 1.1-1.9 1.9-2.7.8-.8 1.7-1.4 2.6-1.8 1.2-.5 2.7-.8 4.3-.8 3 0 5.3.9 7.1 2.7s2.7 4.3 2.7 7.6c0 3.2-.9 5.7-2.6 7.5s-4.1 2.7-7.1 2.7-5.4-.9-7.1-2.7c-1.8-1.8-2.7-4.3-2.7-7.4zm4.2-.2c0 2.2.5 4 1.6 5.1 1 1.2 2.4 1.7 4 1.7s2.9-.6 4-1.7c1-1.2 1.6-2.9 1.6-5.2 0-2.3-.5-4-1.5-5.1-1-1.1-2.3-1.7-4-1.7s-3 .6-4 1.7c-1.2 1.2-1.7 2.9-1.7 5.2zm31.2 2.7l3.9 1.2c-.6 2.2-1.6 3.8-3 4.8s-3.2 1.6-5.3 1.6c-2.7 0-4.8-.9-6.6-2.7s-2.6-4.3-2.6-7.4c0-3.3.9-5.9 2.6-7.7s4-2.7 6.8-2.7c2.5 0 4.4.7 6 2.2.9.8 1.6 2.1 2.1 3.7l-4 .9c-.2-1-.7-1.8-1.5-2.4-.8-.6-1.7-.9-2.7-.9-1.5 0-2.7.5-3.6 1.6s-1.4 2.8-1.4 5.1c0 2.5.5 4.3 1.4 5.4s2 1.5 3.5 1.5c1.1 0 2-.3 2.8-1s1.3-1.8 1.6-3.2z",
    fill: "#fff"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 18.121,
    y1: 50.468,
    x2: 55.041,
    y2: 87.389,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#006186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#005f83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#005a7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#005373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#004865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#003953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#00253c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#00031d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4 25.7c-.5 0-1 .2-1.4.3-.5.2-1 .4-1.4.6-.7.4-1.2.8-1.5 1.3-.3.5-.6 1.1-.8 1.7-.9 2.4-2.2 6-4 11.3-1.8 5.1-3.6 10.5-5.6 16H45l-8.7-24.4-7.9 24.4h-4.7c-2.6-7.5-4.6-13.3-6-17.2-1.4-4.1-2.5-7.4-3.5-10.2-.3-.8-.6-1.4-1-1.8-.4-.4-.9-.8-1.4-1.2-.4-.3-.9-.5-1.3-.6-.5-.1-1-.2-1.6-.3v-1.8h17.6v1.8c-1 .1-1.8.2-2.3.4-.5.1-.9.2-1.2.4-.3.1-.5.3-.5.4-.1.1-.1.3-.1.4 0 .2 0 .4.1.6.1.2.1.4.2.7.4 1.2 1.1 3.5 2.3 6.8 1.1 3.4 2.5 7.5 4.2 12.5L36.7 24h4.9l8.7 24.5c1.3-4 2.3-7.2 3.1-9.7.8-2.5 1.4-4.7 1.9-6.4.3-1.1.6-2 .7-2.8.2-.7.3-1.4.3-1.9 0-.3-.2-.6-.5-.8-.3-.2-.7-.4-1.2-.6-.4-.1-1-.3-1.7-.3-.7-.1-1.3-.2-1.8-.2v-2h13.3v1.9z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 45.069,
    y1: 74.205,
    x2: 58.569,
    y2: 87.705,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#dff1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#dceef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#d3e4ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#c4d6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#b1c5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9ab0c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#819ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#64829f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#426c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#06577a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015679"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    fillOpacity: 0,
    stroke: "#01415e",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.ccf75a033b4c5e5553cfc27db1415001.svg";
export { ForwardRef as ReactComponent };